var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBlackView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9818 7.61652L9.88553 13.4357C9.53915 13.7475 9.01957 13.7475 8.70783 13.4011C8.39609 13.0547 8.39609 12.5351 8.74247 12.2234L13.3493 7.82434H1.57237C1.08743 7.82434 0.741053 7.47796 0.741053 6.99303C0.741053 6.54273 1.08743 6.16171 1.57237 6.16171H13.3493L8.74247 1.7973C8.39609 1.48556 8.39609 0.93135 8.70783 0.619607C9.01957 0.273225 9.57378 0.273225 9.88553 0.584969L15.9818 6.40418C16.155 6.57737 16.2589 6.7852 16.2589 6.99303C16.2589 7.2355 16.155 7.44332 15.9818 7.61652Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlackView);
export default __webpack_public_path__ + "static/media/arrow-right-black-view.b9af536369beda679b0c2cca47ad5456.svg";
export { ForwardRef as ReactComponent };